var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.324,
    height: 42.883,
    viewBox: "0 0 42.324 42.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9,10.889a4.356,4.356,0,0,0,1.091-8.281,4.538,4.538,0,0,1,.741-.554.412.412,0,0,0-.082-.743,3.6,3.6,0,0,0-2.325.152,4.544,4.544,0,0,1,.394-.841.412.412,0,0,0-.423-.617c-1.57.267-2.76,2.09-3.183,3.135a2.791,2.791,0,0,0-.163.566A4.356,4.356,0,0,0,54.9,10.889Z",
    transform: "translate(-42.839 0)",
    fill: "#9995c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.815,51.853a1.515,1.515,0,0,0-2.141.079l-5.092,5.481a3.408,3.408,0,0,0-1.442-.593l-2.217-.352a3.409,3.409,0,0,0-1.572.121L164.2,49.8a1.515,1.515,0,0,0-2.748,1.274l3.65,7.872c-.079.29.022-.3-1.269,8.146l-1.992,2.45.059.072a3.806,3.806,0,0,1,.853,2.4v7.3c.025,0,.049,0,.074,0a1.893,1.893,0,0,0,1.893-1.893V72l2.111-2.6,1.876.358-.493,3.11a1.9,1.9,0,0,0-.023.32l.086,6.786a1.893,1.893,0,0,0,1.893,1.869h.024a1.893,1.893,0,0,0,1.869-1.917l-.084-6.625c.113-.711,2.018-12.695,2.03-12.978l5.883-6.332A1.515,1.515,0,0,0,179.815,51.853Z",
    transform: "translate(-137.975 -41.755)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.517,38.886a3.629,3.629,0,0,0,3.292-5.983,2.324,2.324,0,0,0-.136-.472c-.353-.87-1.344-2.389-2.652-2.612a.343.343,0,0,0-.352.514,3.782,3.782,0,0,1,.328.7,3,3,0,0,0-1.937-.127.343.343,0,0,0-.069.619,3.788,3.788,0,0,1,.617.461,3.629,3.629,0,0,0,.909,6.9Z",
    transform: "translate(-172.241 -25.449)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.672,44.739l-1.522-9.78,4.38-9.446a1.818,1.818,0,0,0-3.3-1.529L17.45,32.138a4.09,4.09,0,0,0-1.887-.145l-2.661.422a4.09,4.09,0,0,0-1.733.71l-6.11-6.577a1.818,1.818,0,1,0-2.664,2.475l7.062,7.6s1.055,6.866,2.437,15.578l-.1,7.952a2.273,2.273,0,0,0,2.244,2.3h.029a2.273,2.273,0,0,0,2.272-2.244l.1-8.146a2.271,2.271,0,0,0-.028-.385l-.592-3.733,2.252-.43,2.534,3.117V57.14a2.273,2.273,0,1,0,4.545,0V49.827a2.273,2.273,0,0,0-.509-1.434Z",
    transform: "translate(-1.909 -19.573)",
    fill: "#9995c7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.f497e6a26412833edc447770bfef54af.svg";
export { ForwardRef as ReactComponent };